import styles from "./tag.module.scss"
import RouterLink from "../link/RouterLink";
import {tagPageUrlFromSlug} from "../../helpers/URLHelpers";

function Tag({ label, withClass }) {
  return (
    <div className={`${styles.tag} ${withClass}`}>{label}</div>
  )
}

function TagStoryTag({ tag_name }) {
  return (
    <RouterLink to={tagPageUrlFromSlug(tag_name)}>
      <Tag label={tag_name} />
    </RouterLink>
  )
}

export default Tag
export { 
  TagStoryTag
}
